/**
 * 用户认证相关工具函数
 */
import config from '@/config'

// 检查用户是否已登录
export const isUserLoggedIn = (): boolean => {
  try {
    const lsToken = localStorage.getItem(config.tokenName)
    const cookieToken = document.cookie.split('; ').find(row => row.startsWith(`${config.tokenName}=`))

    // 仅基于是否存在非空 token 判定登录状态
    const hasValidToken = !!(lsToken && lsToken.trim() !== '') || !!(cookieToken && cookieToken.split('=')[1]?.trim() !== '')
    return hasValidToken
  } catch (error) {
    console.error('检查登录状态时出错:', error)
    return false
  }
}

// 获取用户Token
export const getUserToken = (): string | null => {
  return localStorage.getItem(config.tokenName) || 
    document.cookie.split('; ').find(row => row.startsWith(`${config.tokenName}=`))?.split('=')[1] || 
    null
}

// 设置用户Token
export const setUserToken = (token: string): void => {
  localStorage.setItem(config.tokenName, token)
  // 也可以设置cookie，但通常在login.vue中已经设置了
}

// 清除用户Token（登出）
export const clearUserToken = (): void => {
  // 清除localStorage中的token
  localStorage.removeItem(config.tokenName)
  
  // 清除cookie中的token（通过设置过期时间为过去时间）
  const expireDate = new Date()
  expireDate.setTime(expireDate.getTime() - 1)
  document.cookie = `${config.tokenName}=;expires=${expireDate.toUTCString()};path=/`
  
  console.log('Token已清除:', {
    localStorageToken: localStorage.getItem(config.tokenName),
    cookieToken: document.cookie.includes(config.tokenName)
  })
}

// 获取用户信息
export const getUserInfo = () => {
  try {
    const userInfo = sessionStorage.getItem('userInfo')
    return userInfo ? JSON.parse(userInfo) : null
  } catch (error) {
    console.error('获取用户信息失败:', error)
    return null
  }
}

// 登出
export const logout = (): void => {
  // 清除token
  clearUserToken()
  
  // 清除用户信息
  sessionStorage.removeItem('userInfo')
  
  console.log('用户已登出，所有凭证已清除')
}

// 清除所有认证信息（用于解决登录循环问题）
export const clearAllAuth = (): void => {
  // 清除token
  clearUserToken()
  
  // 清除用户信息
  sessionStorage.removeItem('userInfo')
  
  // 清除其他可能的用户相关数据
  sessionStorage.removeItem('userShowName')
  localStorage.removeItem('type')
  
  console.log('所有认证信息已清除')
} 